<template>
  <div class='container'>
    <div v-if='!isConfirm' class='van-toast' style='z-index: 100;width: 100px;'>
      <van-loading size='32px'>信息提交中...</van-loading>
    </div>
    <div class='module-txt' @click="showTable(0)">
      基本信息<img src='../assets/img/menudown.png' :class="showArray[0] ? 'menuup' : 'menudown'" />
    </div>
    <table class='reports-table' cellspacing=0 v-if="showArray[0]">
      <tr>
        <td class="noborder base">姓名</td>
        <td class="big"><input v-model="info.studentName" class="input-common" /></td>
        <td class="base">性别</td>
        <td class="big">
          <input v-model='sexTxt' readonly @click='showSex = true' class="input-common" />
        </td>
      </tr>
      <tr>
        <td class="noborder base">生日</td>
        <td class="big">
          <input v-model='info.birthday' readonly clickable placeholder='请选择出生日期' @click="showBirth = true"
            class="input-common" />
        </td>
        <td class="base">电话</td>
        <td class="big">
          <input v-model="info.phone" class="input-common" />
        </td>
      </tr>
      <tr>
        <td class="noborder base">身高(cm)</td>
        <td class="big"><input v-model="info.sg" class="input-common" /></td>
        <td class="base">体重(kg)</td>
        <td class="big">
          <input v-model="info.tz" class="input-common" />
        </td>
      </tr>
      <tr>
        <td class="base noborder">建档日期</td>
        <td colspan="3" class="txt-left">
          <input v-model='info.archivesDate' readonly clickable @click="showArchives = true" class="input-common" />
        </td>
      </tr>
    </table>
    <div class='module-txt' :style="showArray[0] ? '' : 'border-top: 0.01rem solid #ccc'" @click="showTable(1)">
      视力及眼压<img src='../assets/img/menudown.png' :class="showArray[1] ? 'menuup' : 'menudown'" />
    </div>
    <table class='reports-table' cellspacing=0 v-if="showArray[1]">
      <tr>
        <td></td>
        <td>视力</td>
        <td>矫正视力</td>
        <td>眼压</td>
      </tr>
      <tr>
        <td class="noborder base">右眼</td>
        <td class="big">
          <div class="flex input-div" @click='showRightShili = true'>
            <div>
              <input class="small" placeholder='请选择' v-model='rightShiliTxt' readonly>
            </div>
            <div><img src="../assets/img/down.png" class='down-img'></div>
          </div>
        </td>
        <td class="big">
          <div class="flex input-div" @click='showGRightShili = true'>
            <input class="small" placeholder='请选择' v-model='gRightShiliTxt' readonly>
            <div><img src="../assets/img/down.png" class='down-img'></div>
          </div>
        </td>
        <td>
          <div class="input-div"><input v-model="info.rightPressure" class="small2" /></div>
        </td>
      </tr>
      <tr>
        <td class="base">左眼</td>
        <td class="big">
          <div class="flex input-div" @click='showLeftShili = true'>
            <div><input placeholder='请选择' class="small" v-model='leftShiliTxt' readonly></div>
            <div><img src="../assets/img/down.png" class='down-img'></div>
          </div>
        </td>
        <td class="big">
          <div class="flex input-div" @click='showGLeftShili = true'>
            <input class="small" placeholder='请选择' v-model='gLeftShiliTxt' readonly>
            <div><img src="../assets/img/down.png" class='down-img'></div>
          </div>
        </td>
        <td>
          <div class="input-div"><input v-model="info.leftPressure" class="small2" /></div>
        </td>
      </tr>
      <tr>
        <td></td>
        <td colspan="3">
          <div class="flex input-div" @click='showGlassType = true'>
            <input placeholder='戴镜类型' v-model='glassesTypeTxt' readonly style="width: 5rem;text-align: center;">
            <div><img src="../assets/img/down.png" class='down-img'></div>
          </div>
        </td>
      </tr>
    </table>
    <div class='module-txt' :style="showArray[1] ? '' : 'border-top: 0.01rem solid #ccc'" @click="showTable(2)">
      非散瞳 (电脑)验光<img src='../assets/img/menudown.png' :class="showArray[2] ? 'menuup' : 'menudown'" />
    </div>
    <table class='reports-table' cellspacing=0 v-if="showArray[2]">
      <tr>
        <td class="noborder base"></td>
        <td class="big2">球镜</td>
        <td class="big2">柱镜</td>
        <td class="big2">轴位</td>
      </tr>
      <tr>
        <td class="noborder">右眼</td>
        <td>
          <div class="flex input-div">
            <input placeholder='请选择' readonly class="small1" v-model='info.rightBallAvg' @click='showRightQj0 = true;' />
            <div><img src="../assets/img/down.png" @click='showRightQj0 = true' class='down-img'></div>
          </div>
        </td>
        <td>
          <div class="flex input-div">
            <input placeholder='请选择' v-model='info.rightSylAvg' readonly @click='showRightZj0 = true' class="small1" />
            <div><img src="../assets/img/down.png" @click='showRightZj0 = true' class='down-img'></div>
          </div>
        </td>
        <td>
          <div class="flex input-div"><input placeholder='请选择' v-model='info.rightAxialAvg' class="small1" />
            <div><img src="../assets/img/down.png" @click='showRightZw0 = true' class='down-img'></div>
          </div>
        </td>
      </tr>

      <tr>
        <td class="noborder">左眼</td>
        <td>
          <div class="flex input-div">
            <input placeholder='请选择' readonly class="small1" v-model='info.leftBallAvg' @click='showLeftQj0 = true' />
            <div><img src="../assets/img/down.png" @click='showLeftQj0 = true' class='down-img'></div>
          </div>
        </td>
        <td>
          <div class="flex input-div">
            <input placeholder='请选择' readonly class="small1" v-model='info.leftSylAvg' @click='showLeftZj0 = true' />
            <div><img src="../assets/img/down.png" @click='showLeftZj0 = true' class='down-img'></div>

          </div>
        </td>
        <td>
          <div class="flex input-div">
            <input placeholder='请选择' class="small1" v-model='info.leftAxialAvg' />
            <div><img src="../assets/img/down.png" @click='showLeftZw0 = true' class='down-img'></div>

          </div>
        </td>
      </tr>

      <tr>
        <td>瞳距(mm)</td>
        <td colspan="3" class="txt-left">
          <div class="input-div"><input v-model='info.pupilDistance' /></div>
        </td>
      </tr>
      <tr>
        <td style="padding: 0.1rem 0;">验光图片</td>
        <td colspan="3" class="txt-left" @click="setImgIndex(1)">
          <van-uploader :after-read='afterRead' multiple>
            <div class='other-photo'>+</div>
          </van-uploader><br />
          <span v-for="(item, index) in imgList1" :key="index" class='dz-img'>
            <div v-if="item && item != ''">
              <img :src="item.indexOf('http') >= 0 ? item : imgPro + item" @click="goPriview(item)" /><br />
              <span @click="goPriview(item)">预览</span>
              <span @click='goDel(index, 1)'>删除</span>
            </div>
          </span>
        </td>
      </tr>
    </table>
    <div class='module-txt' :style="showArray[2] ? '' : 'border-top: 0.01rem solid #ccc'" @click="showTable(3)">
      非散瞳 (显然)验光<img src='../assets/img/menudown.png' :class="showArray[3] ? 'menuup' : 'menudown'" />
    </div>
    <table class='reports-table' cellspacing=0 v-if="showArray[3]">
      <tr>
        <td class="noborder base"></td>
        <td class="base">球镜</td>
        <td class="base">柱镜</td>
        <td class="base">轴位</td>
        <td class="base">矫正视力</td>
      </tr>
      <tr>
        <td class="noborder">右眼</td>
        <td>
          <div class="flex  input-div" style="padding: 0.1rem 0;width: 1.2rem;">
            <input placeholder='请选择' readonly style="width: 0.9rem;" v-model='info.rightBallZhujue'
              @click='showRightQj1 = true' />
            <div><img src="../assets/img/down.png" @click='showRightQj1 = true' class='down-img'></div>
          </div>
        </td>
        <td>
          <div class="flex  input-div" style="padding: 0.1rem 0;width: 1.2rem;">
            <input placeholder='请选择' style="width: 0.9rem;" v-model='info.rightSylZhujue' readonly
              @click='showRightZj1 = true' />
            <div><img src="../assets/img/down.png" @click='showRightZj1 = true' class='down-img'></div>
          </div>
        </td>
        <td>
          <div class="flex  input-div" style="padding: 0.1rem 0;width: 1.2rem;">
            <input placeholder='请选择' readonly style="width: 0.9rem;" v-model='info.rightAxialZhujue' />
            <div><img src="../assets/img/down.png" @click='showRightZw1 = true' class='down-img'></div>
          </div>
        </td>
        <td>
          <div class="flex  input-div" style="padding: 0.1rem 0;width: 1.2rem;">
            <input placeholder='请选择' readonly style="width: 0.9rem;" v-model='rightJzTxt0' />
            <div><img src="../assets/img/down.png" @click='showRightJz0 = true' class='down-img'></div>
          </div>

        </td>
      </tr>

      <tr>
        <td class="noborder">左眼</td>
        <td>

          <div class="flex  input-div" style="padding: 0.1rem 0;width: 1.2rem;">
            <input placeholder='请选择' readonly style="width: 0.9rem;" v-model='info.leftBallZhujue'
              @click='showLeftQj1 = true' />
            <div><img src="../assets/img/down.png" @click='showLeftQj1 = true' class='down-img'></div>

          </div>
        </td>
        <td>

          <div class="flex  input-div" style="padding: 0.1rem 0;width: 1.2rem;">
            <input placeholder='请选择' readonly style="width: 0.9rem;" v-model='info.leftSylZhujue'
              @click='showLeftZj1 = true' />
            <div><img src="../assets/img/down.png" @click='showLeftZj1 = true' class='down-img'></div>

          </div>
        </td>
        <td>
          <div class="flex  input-div" style="padding: 0.1rem 0;width: 1.2rem;">
            <input placeholder='请选择' readonly style="width: 0.9rem;" v-model='info.leftAxialZhujue' />
            <div><img src="../assets/img/down.png" @click='showLeftZw1 = true' class='down-img'></div>

          </div>
        </td>

        <td>
          <div class="flex  input-div" style="padding: 0.1rem 0;width: 1.2rem;">
            <input placeholder='请选择' readonly style="width: 0.9rem;" v-model='leftJzTxt0' />
            <div><img src="../assets/img/down.png" @click='showLeftJz0 = true' class='down-img'></div>
          </div>
        </td>
      </tr>

      <tr>
        <td>瞳距(mm)</td>
        <td colspan="4" class="txt-left">
          <div class="input-div"><input v-model='info.xrygPupilDistance' class="big-txt" /></div>
        </td>
      </tr>
      <tr>
        <td>验光图片</td>
        <td colspan="4" class="txt-left" @click="setImgIndex(2)">
          <van-uploader :after-read='afterRead' multiple>
            <div class='other-photo'>+</div>
          </van-uploader><br />
          <span v-for="(item, index) in imgList2" :key="index" class='dz-img'>
            <div v-if="item">
              <img :src="item" @click="goPriview(item)" /><br />
              <span @click="goPriview(item)">预览</span>
              <span @click='goDel(index, 2)'>删除</span>
            </div>
          </span>
        </td>
      </tr>
    </table>
    <div class='module-txt' :style="showArray[3] ? '' : 'border-top: 0.01rem solid #ccc'" @click="showTable(4)">
      散瞳 (电脑)验光<img src='../assets/img/menudown.png' :class="showArray[4] ? 'menuup' : 'menudown'" />
    </div>
    <table class='reports-table' cellspacing=0 v-if="showArray[4]">
      <tr>
        <td class="noborder base"></td>
        <td class="big2">球镜</td>
        <td class="big2">柱镜</td>
        <td class="big2">轴位</td>
      </tr>
      <tr>
        <td class="noborder">右眼</td>
        <td>
          <div class="flex input-div">
            <input placeholder='请选择' readonly class="small1" v-model='info.rightBallAvgAfter'
              @click='showRightQj2 = true' />
            <div><img src="../assets/img/down.png" @click='showRightQj2 = true' class='down-img'></div>
          </div>
        </td>
        <td>
          <div class="flex input-div">
            <input placeholder='请选择' v-model='info.rightSylAvgAfter' readonly @click='showRightZj2 = true'
              class="small1" />
            <div><img src="../assets/img/down.png" @click='showRightZj2 = true' class='down-img'></div>
          </div>
        </td>
        <td>
          <div class="flex input-div"><input placeholder='请选择' v-model='info.rightAxialAvgAfter' class="small1" />
            <div><img src="../assets/img/down.png" @click='showRightZw2 = true' class='down-img'></div>
          </div>
        </td>
      </tr>

      <tr>
        <td class="noborder">左眼</td>
        <td>
          <div class="flex input-div">
            <input placeholder='请选择' readonly class="small1" v-model='info.leftBallAvgAfter'
              @click='showLeftQj2 = true' />
            <div><img src="../assets/img/down.png" @click='showLeftQj2 = true' class='down-img'></div>

          </div>
        </td>
        <td>
          <div class="flex input-div">
            <input placeholder='请选择' readonly class="small1" v-model='info.leftSylAvgAfter' @click='showLeftZj2 = true' />
            <div><img src="../assets/img/down.png" @click='showLeftZj2 = true' class='down-img'></div>

          </div>
        </td>
        <td>
          <div class="flex input-div">
            <input placeholder='请选择' class="small1" v-model='info.leftAxialAvgAfter' />
            <div><img src="../assets/img/down.png" @click='showLeftZw2 = true' class='down-img'></div>

          </div>
        </td>
      </tr>
      <tr>
        <td>瞳距(mm)</td>
        <td colspan="3" class="txt-left">
          <div class="input-div"><input v-model='info.pupilDistanceAfter' class="big-txt" /></div>
        </td>
      </tr>
      <tr>
        <td style="padding: 0.1rem 0;">验光图片</td>
        <td colspan="3" class="txt-left" @click="setImgIndex(3)">
          <van-uploader :after-read='afterRead' multiple>
            <div class='other-photo'>+</div>
          </van-uploader><br />

          <span v-for="(item, index) in imgList3" :key="index" class='dz-img'>
            <img :src="item" @click="goPriview(item)" /><br />
            <span @click="goPriview(item)">预览</span>
            <span @click='goDel(index, 3)'>删除</span>
          </span>
        </td>
      </tr>
    </table>
    <div class='module-txt' :style="showArray[4] ? '' : 'border-top: 0.01rem solid #ccc'" @click="showTable(5)">
      散瞳 (显然)验光<img src='../assets/img/menudown.png' :class="showArray[5] ? 'menuup' : 'menudown'" />
    </div>
    <table class='reports-table' :style="showArray[5] ? '' : 'border-top: 0.01rem solid #ccc'" cellspacing=0
      v-if="showArray[5]">
      <tr>
        <td class="noborder base"></td>
        <td class="base">球镜</td>
        <td class="base">柱镜</td>
        <td class="base">轴位</td>
        <td class="base">矫正视力</td>
      </tr>
      <tr>
        <td class="noborder">右眼</td>
        <td>
          <div class="flex  input-div" style="padding: 0.1rem 0;width: 1.2rem;">
            <input placeholder='请选择' readonly style="width: 0.9rem;" v-model='info.rightballchapian'
              @click='showRightQj3 = true' />
            <div><img src="../assets/img/down.png" @click='showRightQj3 = true' class='down-img'></div>
          </div>
        </td>
        <td>
          <div class="flex  input-div" style="padding: 0.1rem 0;width: 1.2rem;">
            <input placeholder='请选择' readonly style="width: 0.9rem;" v-model='info.rightsylchapian'
              @click='showRightZj3 = true' />
            <div><img src="../assets/img/down.png" @click='showRightZj3 = true' class='down-img'></div>
          </div>
        </td>
        <td>
          <div class="flex  input-div" style="padding: 0.1rem 0;width: 1.2rem;">
            <input placeholder='请选择' readonly style="width: 0.9rem;" v-model='info.rightaxialchapian' />
            <div><img src="../assets/img/down.png" @click='showRightZw3 = true' class='down-img'></div>
          </div>
        </td>
        <td>
          <div class="flex  input-div" style="padding: 0.1rem 0;width: 1.2rem;">
            <input placeholder='请选择' readonly style="width: 0.9rem;" v-model='rightJzTxt1' />
            <div><img src="../assets/img/down.png" @click='showRightJz1 = true' class='down-img'></div>
          </div>

        </td>
      </tr>

      <tr>
        <td class="noborder">左眼</td>
        <td>
          <div class="flex  input-div" style="padding: 0.1rem 0;width: 1.2rem;">
            <input placeholder='请选择' readonly style="width: 0.9rem;" v-model='info.leftballchapian'
              @click='showLeftQj3 = true' />
            <div><img src="../assets/img/down.png" @click='showLeftQj3 = true' class='down-img'></div>

          </div>
        </td>
        <td>
          <div class="flex  input-div" style="padding: 0.1rem 0;width: 1.2rem;">
            <input placeholder='请选择' readonly style="width: 0.9rem;" v-model='info.leftsylchapian'
              @click='showLeftZj3 = true' />
            <div><img src="../assets/img/down.png" @click='showLeftZj3 = true' class='down-img'></div>

          </div>
        </td>
        <td>
          <div class="flex  input-div" style="padding: 0.1rem 0;width: 1.2rem;">
            <input placeholder='请选择' readonly style="width: 0.9rem;" v-model='info.leftaxialchapian' />
            <div><img src="../assets/img/down.png" @click='showLeftZw3 = true' class='down-img'></div>

          </div>
        </td>

        <td>

          <div class="flex  input-div" style="padding: 0.1rem 0;width: 1.2rem;">
            <input placeholder='请选择' readonly style="width: 0.9rem;" v-model='leftJzTxt1' />
            <div><img src="../assets/img/down.png" @click='showLeftJz1 = true' class='down-img'></div>
          </div>
        </td>
      </tr>
      <tr>
        <td>瞳距(mm)</td>
        <td colspan="4" class="txt-left">
          <div class="input-div"><input v-model='info.xrygsthPupilDistance' class="big-txt" /></div>
        </td>
      </tr>
      <tr>
        <td>验光图片</td>
        <td colspan="4" class="txt-left" @click="setImgIndex(4)">
          <van-uploader :after-read='afterRead' multiple>
            <div class='other-photo'>+</div>
          </van-uploader><br />
          <span v-for="(item, index) in imgList4" :key="index" class='dz-img'>
            <div v-if="item">
              <img :src="item" @click="goPriview(item)" /><br />
              <span @click="goPriview(item)">预览</span>
              <span @click='goDel(index, 4)'>删除</span>
            </div>
          </span>
        </td>
      </tr>
    </table>
    <div class='module-txt' :style="showArray[6] ? '' : 'border-top: 0.01rem solid #ccc'" @click="showTable(6)">
      复验 (电脑)验光<img src='../assets/img/menudown.png' :class="showArray[6] ? 'menuup' : 'menudown'" />
    </div>
    <table class='reports-table' cellspacing=0 v-if="showArray[6]">
      <tr>
        <td class="noborder base"></td>
        <td class="big2">球镜</td>
        <td class="big2">柱镜</td>
        <td class="big2">轴位</td>
      </tr>
      <tr>
        <td class="noborder">右眼</td>
        <td>
          <div class="flex input-div">
            <input placeholder='请选择' readonly class="small1" v-model='info.rightBallAvgAfter1'
              @click='showRightQj4 = true' />
            <div><img src="../assets/img/down.png" @click='showRightQj4 = true' class='down-img'></div>
          </div>
        </td>
        <td>
          <div class="flex input-div">
            <input placeholder='请选择' v-model='info.rightSylAvgAfter1' readonly @click='showRightZj4 = true'
              class="small1" />
            <div><img src="../assets/img/down.png" @click='showRightZj4 = true' class='down-img'></div>
          </div>
        </td>
        <td>
          <div class="flex input-div"><input placeholder='请选择' v-model='info.rightAxialAvgAfter1' class="small1" />
            <div><img src="../assets/img/down.png" @click='showRightZw4 = true' class='down-img'></div>
          </div>
        </td>
      </tr>

      <tr>
        <td class="noborder">左眼</td>
        <td>
          <div class="flex input-div">
            <input placeholder='请选择' readonly class="small1" v-model='info.leftBallAvgAfter1'
              @click='showLeftQj4 = true' />
            <div><img src="../assets/img/down.png" @click='showLeftQj4 = true' class='down-img'></div>

          </div>
        </td>
        <td>
          <div class="flex input-div">
            <input placeholder='请选择' readonly class="small1" v-model='info.leftSylAvgAfter1'
              @click='showLeftZj4 = true' />
            <div><img src="../assets/img/down.png" @click='showLeftZj4 = true' class='down-img'></div>

          </div>
        </td>
        <td>
          <div class="flex input-div">
            <input placeholder='请选择' class="small1" v-model='info.leftAxialAvgAfter1' />
            <div><img src="../assets/img/down.png" @click='showLeftZw4 = true' class='down-img'></div>

          </div>
        </td>
      </tr>
      <tr>
        <td>瞳距(mm)</td>
        <td colspan="3" class="txt-left">
          <div class="input-div"><input v-model='info.pupilDistanceAfter1' /></div>
        </td>
      </tr>
      <tr>
        <td style="padding: 0.2rem 0;">验光图片</td>
        <td colspan="3" class="txt-left" @click="setImgIndex(5)">
          <van-uploader :after-read='afterRead' multiple>
            <div class='other-photo'>+</div>
          </van-uploader><br />
          <span v-for="(item, index) in  imgList5" :key="index" class='dz-img'>
            <div v-if="item">
              <img :src="item" @click="goPriview(item)" /><br />
              <span @click="goPriview(item)">预览</span>
              <span @click='goDel(index, 5)'>删除</span>
            </div>
          </span>
        </td>
      </tr>
    </table>
    <div class='module-txt' :style="showArray[6] ? '' : 'border-top: 0.01rem solid #ccc'" @click="showTable(7)">
      复验 (显然)验光<img src='../assets/img/menudown.png' :class="showArray[7] ? 'menuup' : 'menudown'" />
    </div>
    <table class='reports-table' cellspacing=0 v-if="showArray[7]">
      <tr>
        <td class="noborder base"></td>
        <td class="base">球镜</td>
        <td class="base">柱镜</td>
        <td class="base">轴位</td>
        <td class="base">矫正视力</td>
      </tr>
      <tr>
        <td class="noborder">右眼</td>
        <td>
          <div class="flex  input-div" style="padding: 0.1rem 0;width: 1.2rem;">
            <input placeholder='请选择' readonly style="width: 0.9rem;" v-model='info.rightBallZhujue1'
              @click='showRightQj5 = true' />
            <div><img src="../assets/img/down.png" @click='showRightQj5 = true' class='down-img'></div>
          </div>
        </td>
        <td>
          <div class="flex  input-div" style="padding: 0.1rem 0;width: 1.2rem;">
            <input placeholder='请选择' readonly style="width: 0.9rem;" v-model='info.rightSylZhujue1'
              @click='showRightZj5 = true' />
            <div><img src="../assets/img/down.png" @click='showRightZj5 = true' class='down-img'></div>
          </div>
        </td>
        <td>
          <div class="flex  input-div" style="padding: 0.1rem 0;width: 1.2rem;">
            <input placeholder='请选择' readonly style="width: 0.9rem;" v-model='info.rightAxialZhujue1' />
            <div><img src="../assets/img/down.png" @click='showRightZw5 = true' class='down-img'></div>
          </div>
        </td>
        <td>
          <div class="flex  input-div" style="padding: 0.1rem 0;width: 1.2rem;">
            <input placeholder='请选择' readonly style="width: 0.9rem;" v-model='rightJzTxt2' />
            <div><img src="../assets/img/down.png" @click='showLeftJz2 = true' class='down-img'></div>
          </div>
        </td>
      </tr>

      <tr>
        <td class="noborder">左眼</td>
        <td>
          <div class="flex  input-div" style="padding: 0.1rem 0;width: 1.2rem;">
            <input placeholder='请选择' readonly style="width: 0.9rem;" v-model='info.leftBallZhujue1'
              @click='showLeftQj5 = true' />
            <div><img src="../assets/img/down.png" @click='showLeftQj5 = true' class='down-img'></div>

          </div>
        </td>
        <td>
          <div class="flex  input-div" style="padding: 0.1rem 0;width: 1.2rem;">
            <input placeholder='请选择' readonly style="width: 0.9rem;" v-model='info.leftSylZhujue1'
              @click='showLeftZj5 = true' />
            <div><img src="../assets/img/down.png" @click='showLeftZj5 = true' class='down-img'></div>

          </div>
        </td>
        <td>
          <div class="flex  input-div" style="padding: 0.1rem 0;width: 1.2rem;">
            <input placeholder='请选择' readonly style="width: 0.9rem;" v-model='info.leftAxialZhujue1' />
            <div><img src="../assets/img/down.png" @click='showLeftZw5 = true' class='down-img'></div>

          </div>
        </td>

        <td>
          <div class="flex  input-div" style="padding: 0.1rem 0;width: 1.2rem;">
            <input placeholder='请选择' readonly style="width: 0.9rem;" v-model='leftJzTxt2' />
            <div><img src="../assets/img/down.png" @click='showLeftJz2 = true' class='down-img'></div>
          </div>
        </td>
      </tr>
      <tr>
        <td>瞳距(mm)</td>
        <td colspan="4" class="txt-left">
          <div class="input-div"><input v-model='info.xrygfyPupilDistance' class="big-txt" /></div>
        </td>
      </tr>
      <tr>
        <td>验光图片</td>
        <td colspan="4" class="txt-left" @click="setImgIndex(6)">
          <van-uploader :after-read='afterRead' multiple>
            <div class='other-photo'>+</div>
          </van-uploader><br />
          <span v-for="(item, index) in  imgList6" :key="index" class='dz-img'>
            <div v-if="item">
              <img :src="item" @click="goPriview(item)" /><br />
              <span @click="goPriview(item)">预览</span>
              <span @click='goDel(index, 6)'>删除</span>
            </div>
          </span>
        </td>
      </tr>
    </table>
    <div class='module-txt' :style="showArray[7] ? '' : 'border-top: 0.01rem solid #ccc'" @click="showTable(8)">
      配镜单上传<img src='../assets/img/menudown.png' :class="showArray[8] ? 'menuup' : 'menudown'" />
    </div>
    <table class='reports-table' cellspacing=0 v-if="showArray[8]">
      <tr>
        <td class="noborder" @click="setImgIndex(10)">
          <van-uploader :after-read='afterRead' multiple>
            <div class='other-photo'>+</div>
          </van-uploader><br />
          <span v-for="(item, index) in  imgList10" :key="index" class='dz-img'>
            <div v-if="item">
              <img :src="item" @click="goPriview(item)" /><br />
              <span @click="goPriview(item)">预览</span>
              <span @click='goDel(index, 10)'>删除</span>
            </div>
          </span>
        </td>
      </tr>
    </table>
    <div class='module-txt' :style="showArray[8] ? '' : 'border-top: 0.01rem solid #ccc'" @click="showTable(9)">
      曲率眼轴(生物测量仪)<img src='../assets/img/menudown.png' :class="showArray[9] ? 'menuup' : 'menudown'" />
    </div>
    <table class='reports-table' cellspacing=0 v-if="showArray[9]">
      <tr>
        <td></td>
        <td>眼轴</td>
        <td>曲率K1</td>
        <td>曲率K2</td>
      </tr>
      <tr>
        <td>右眼</td>
        <td><input v-model='info.rightAxialLength' placeholder='请输入' class="input-common" /></td>
        <td><input v-model='info.rightEyeCurvatureR1' placeholder='请输入' class="input-common" /></td>
        <td><input v-model='info.rightEyeCurvatureR2' placeholder='请输入' class="input-common" /></td>
      </tr>

      <tr>
        <td>左眼</td>
        <td><input v-model='info.leftAxialLength' placeholder='请输入' class="input-common" /></td>
        <td><input v-model='info.leftEyeCurvatureR1' placeholder='请输入' class="input-common" /></td>
        <td><input v-model='info.leftEyeCurvatureR2' placeholder='请输入' class="input-common" /></td>
      </tr>
      <tr>
        <td class="txt-left">拍照上传生物测量仪图片</td>
        <td @click="setImgIndex(7)" colspan="3">
          <van-uploader :after-read='afterRead' multiple>
            <div class='other-photo'>+</div>
          </van-uploader><br />
          <div v-for="(item, index) in  imgList7" :key="index" class='dz-img'>
            <div v-if="item">
              <img :src="item" @click="goPriview(item)" /><br />
              <span @click="goPriview(item)">预览</span>
              <span @click='goDel(index, 7)'>删除</span>
            </div>
          </div>
        </td>
      </tr>
    </table>
    <div class='module-txt' :style="showArray[9] ? '' : 'border-top: 0.01rem solid #ccc'" @click="showTable(10)">
      角膜地形图<img src='../assets/img/menudown.png' :class="showArray[10] ? 'menuup' : 'menudown'" />
    </div>
    <table class='reports-table' cellspacing=0 v-if="showArray[10]">
      <tr>
        <td style="line-height:1rem;vertical-align: top;width: 1rem;"><span>右眼</span></td>
        <td @click="setImgIndex(8)" style="vertical-align: top;width: 2.6rem;">
          <van-uploader :after-read='afterRead' multiple>
            <div class='other-photo'>+</div>
          </van-uploader><br />
          <span v-for="(item, index) in  imgList8" :key="index" class='dz-img'>
            <div v-if="item">
              <img :src="item" @click="goPriview(item)" /><br />
              <span @click="goPriview(item)">预览</span>
              <span @click='goDel(index, 8)'>删除</span>
            </div>
          </span>
        </td>
        <td style="line-height:1rem;vertical-align: top;width: 1rem;">左眼</td>
        <td @click="setImgIndex(9)" style="vertical-align: top;width: 2.6rem;">
          <van-uploader :after-read='afterRead' multiple>
            <div class='other-photo'>+</div>
          </van-uploader><br />
          <span v-for="(item, index) in  imgList9" :key="index" class='dz-img'>
            <div v-if="item">
              <img :src="item" @click="goPriview(item)" /><br />
              <span @click="goPriview(item)">预览</span>
              <span @click='goDel(index, 9)'>删除</span>
            </div>
          </span>
        </td>
      </tr>
    </table>
    <div class='module-txt' :style="showArray[10] ? '' : 'border-top: 0.01rem solid #ccc'" @click="showTable(11)">
      视功能<img src='../assets/img/menudown.png' :class="showArray[11] ? 'menuup' : 'menudown'" />
    </div>
    <table class='reports-table' cellspacing=0 v-if="showArray[11]">
      <tr>
        <td class="noborder" @click="setImgIndex(11)">
          <van-uploader :after-read='afterRead' multiple>
            <div class='other-photo'>+</div>
          </van-uploader><br />
          <span v-for="(item, index) in  imgList11" :key="index" class='dz-img'>
            <div v-if="item">
              <img :src="item" @click="goPriview(item)" /><br />
              <span @click="goPriview(item)">预览</span>
              <span @click='goDel(index, 11)'>删除</span>
            </div>
          </span>
        </td>
      </tr>
    </table>

    <div class="module-txt show-table" :style="showArray[11] ? '' : 'border-top: 0.01rem solid #ccc'"
      @click="showTable(12)">
      其他检查图片<img src='../assets/img/menudown.png' :class="showArray[12] ? 'menuup' : 'menudown'" />
    </div>
    <div style='margin: 0.3rem 0.1rem;text-align: left;' @click="setImgIndex(12)" v-show="showArray[12]">
      <van-uploader :after-read='afterRead' multiple>
        <div class='other-photo'>+</div>
      </van-uploader>
    </div>
    <div class='dz-img-box' v-show="showArray[12]">
      <div v-for='(item, index) in imgList12' :key='index' class='dz-img'>
        <img :src='item' style="width: 2rem;" @click="goPriview(item)" /><br />
        <span @click="goPriview(item)">预览</span>
        <span @click='goDel(index, 12)'>删除</span>
      </div>
    </div>
    <van-button class='submit-btn' v-show='isConfirm' @click='submitInfo()'>提交</van-button>
    <van-popup v-model='showSex' position='bottom'>
      <van-picker :columns='listSex' show-toolbar value-key='txt' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showSex = false' @confirm='onConfirmSex' />
    </van-popup>
    <van-popup v-model='showBirth' position='bottom'>
      <van-datetime-picker :min-date='minDate' v-model='currentDate' type='date' @cancel='showBirth = false'
        @confirm='onConfirmBirth' />
    </van-popup>
    <van-popup v-model='showArchives' position='bottom'>
      <van-datetime-picker :min-date='minDate' v-model='currentDate1' type='date' @cancel='showArchives = false'
        @confirm='onConfirmArchives' />
    </van-popup>
    <van-popup v-model='showRightShili' position='bottom'>
      <van-picker :columns='listShili' show-toolbar value-key='txt' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showRightShili = false' @confirm='onConfirmRightShili' />
    </van-popup>
    <van-popup v-model='showLeftShili' position='bottom'>
      <van-picker :columns='listShili' show-toolbar value-key='txt' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showLeftShili = false' @confirm='onConfirmLeftShili' />
    </van-popup>
    <van-popup v-model='showGRightShili' position='bottom'>
      <van-picker :columns='listShili' show-toolbar value-key='txt' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showGRightShili = false' @confirm='onConfirmGRightShili' />
    </van-popup>
    <van-popup v-model='showGLeftShili' position='bottom'>
      <van-picker :columns='listShili' show-toolbar value-key='txt' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showGLeftShili = false' @confirm='onConfirmGLeftShili' />
    </van-popup>
    <van-popup v-model='showGlassType' position='bottom'>
      <van-picker :columns='listGlassType' show-toolbar value-key='txt' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showGlassType = false' @confirm='onConfirmGlassType' />
    </van-popup>
    <van-popup v-model='showRightQj0' position='bottom'>
      <van-picker :columns='listJl' show-toolbar :default-index='40' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showRightQj0 = false' @confirm='onConfirmRightQj0' />
    </van-popup>
    <van-popup v-model='showRightQj1' position='bottom'>
      <van-picker :columns='listJl' show-toolbar :default-index='40' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showRightQj1 = false' @confirm='onConfirmRightQj1' />
    </van-popup>
    <van-popup v-model='showRightQj2' position='bottom'>
      <van-picker :columns='listJl' show-toolbar :default-index='40' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showRightQj2 = false' @confirm='onConfirmRightQj2' />
    </van-popup>
    <van-popup v-model='showRightQj3' position='bottom'>
      <van-picker :columns='listJl' show-toolbar :default-index='40' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showRightQj3 = false' @confirm='onConfirmRightQj3' />
    </van-popup>
    <van-popup v-model='showRightQj4' position='bottom'>
      <van-picker :columns='listJl' show-toolbar :default-index='40' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showRightQj4 = false' @confirm='onConfirmRightQj4' />
    </van-popup>
    <van-popup v-model='showRightQj5' position='bottom'>
      <van-picker :columns='listJl' show-toolbar :default-index='40' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showRightQj5 = false' @confirm='onConfirmRightQj5' />
    </van-popup>
    <van-popup v-model='showRightZj0' position='bottom'>
      <van-picker :columns='listJl' show-toolbar :default-index='40' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showRightZj0 = false' @confirm='onConfirmRightZj0' />
    </van-popup>
    <van-popup v-model='showRightZj1' position='bottom'>
      <van-picker :columns='listJl' show-toolbar :default-index='40' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showRightZj1 = false' @confirm='onConfirmRightZj1' />
    </van-popup>
    <van-popup v-model='showRightZj2' position='bottom'>
      <van-picker :columns='listJl' show-toolbar :default-index='40' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showRightZj2 = false' @confirm='onConfirmRightZj2' />
    </van-popup>
    <van-popup v-model='showRightZj3' position='bottom'>
      <van-picker :columns='listJl' show-toolbar :default-index='40' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showRightZj3 = false' @confirm='onConfirmRightZj3' />
    </van-popup>
    <van-popup v-model='showRightZj4' position='bottom'>
      <van-picker :columns='listJl' show-toolbar :default-index='40' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showRightZj4 = false' @confirm='onConfirmRightZj4' />
    </van-popup>
    <van-popup v-model='showRightZj5' position='bottom'>
      <van-picker :columns='listJl' show-toolbar :default-index='40' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showRightZj5 = false' @confirm='onConfirmRightZj5' />
    </van-popup>
    <van-popup v-model='showRightZw0' position='bottom'>
      <van-picker :columns='listZw' show-toolbar :default-index='59' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showRightZw0 = false' @confirm='onConfirmRightZw0' />
    </van-popup>
    <van-popup v-model='showRightZw1' position='bottom'>
      <van-picker :columns='listZw' show-toolbar :default-index='59' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showRightZw1 = false' @confirm='onConfirmRightZw1' />
    </van-popup>
    <van-popup v-model='showRightZw2' position='bottom'>
      <van-picker :columns='listZw' show-toolbar :default-index='59' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showRightZw2 = false' @confirm='onConfirmRightZw2' />
    </van-popup>
    <van-popup v-model='showRightZw3' position='bottom'>
      <van-picker :columns='listZw' show-toolbar :default-index='59' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showRightZw3 = false' @confirm='onConfirmRightZw3' />
    </van-popup>
    <van-popup v-model='showRightZw4' position='bottom'>
      <van-picker :columns='listZw' show-toolbar :default-index='59' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showRightZw4 = false' @confirm='onConfirmRightZw4' />
    </van-popup>
    <van-popup v-model='showRightZw5' position='bottom'>
      <van-picker :columns='listZw' show-toolbar :default-index='59' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showRightZw5 = false' @confirm='onConfirmRightZw5' />
    </van-popup>
    <van-popup v-model='showRightJz0' position='bottom'>
      <van-picker :columns='listShili' show-toolbar :default-index='3' value-key='txt' cancel-button-text='取消'
        confirm-button-text='确定' @cancel='showRightJz0 = false' @confirm='onConfirmRightJz0' />
    </van-popup>
    <van-popup v-model='showRightJz1' position='bottom'>
      <van-picker :columns='listShili' show-toolbar :default-index='3' value-key='txt' cancel-button-text='取消'
        confirm-button-text='确定' @cancel='showRightJz1 = false' @confirm='onConfirmRightJz1' />
    </van-popup>
    <van-popup v-model='showRightJz2' position='bottom'>
      <van-picker :columns='listShili' show-toolbar :default-index='3' value-key='txt' cancel-button-text='取消'
        confirm-button-text='确定' @cancel='showRightJz2 = false' @confirm='onConfirmRightJz2' />
    </van-popup>
    <van-popup v-model='showLeftQj0' position='bottom'>
      <van-picker :columns='listJl' show-toolbar :default-index='40' value-key='txt' cancel-button-text='取消'
        confirm-button-text='确定' @cancel='showLeftQj0 = false' @confirm='onConfirmLeftQj0' />
    </van-popup>
    <van-popup v-model='showLeftQj1' position='bottom'>
      <van-picker :columns='listJl' show-toolbar :default-index='40' value-key='txt' cancel-button-text='取消'
        confirm-button-text='确定' @cancel='showLeftQj1 = false' @confirm='onConfirmLeftQj1' />
    </van-popup>
    <van-popup v-model='showLeftQj2' position='bottom'>
      <van-picker :columns='listJl' show-toolbar :default-index='40' value-key='txt' cancel-button-text='取消'
        confirm-button-text='确定' @cancel='showLeftQj2 = false' @confirm='onConfirmLeftQj2' />
    </van-popup>
    <van-popup v-model='showLeftQj3' position='bottom'>
      <van-picker :columns='listJl' show-toolbar :default-index='40' value-key='txt' cancel-button-text='取消'
        confirm-button-text='确定' @cancel='showLeftQj3 = false' @confirm='onConfirmLeftQj3' />
    </van-popup>
    <van-popup v-model='showLeftQj4' position='bottom'>
      <van-picker :columns='listJl' show-toolbar :default-index='40' value-key='txt' cancel-button-text='取消'
        confirm-button-text='确定' @cancel='showLeftQj4 = false' @confirm='onConfirmLeftQj4' />
    </van-popup>
    <van-popup v-model='showLeftQj5' position='bottom'>
      <van-picker :columns='listJl' show-toolbar :default-index='40' value-key='txt' cancel-button-text='取消'
        confirm-button-text='确定' @cancel='showLeftQj5 = false' @confirm='onConfirmLeftQj5' />
    </van-popup>
    <van-popup v-model='showLeftZj0' position='bottom'>
      <van-picker :columns='listJl' show-toolbar :default-index='40' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showLeftZj0 = false' @confirm='onConfirmLeftZj0' />
    </van-popup>
    <van-popup v-model='showLeftZj1' position='bottom'>
      <van-picker :columns='listJl' show-toolbar :default-index='40' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showLeftZj1 = false' @confirm='onConfirmLeftZj1' />
    </van-popup>
    <van-popup v-model='showLeftZj2' position='bottom'>
      <van-picker :columns='listJl' show-toolbar :default-index='40' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showLeftZj2 = false' @confirm='onConfirmLeftZj2' />
    </van-popup>
    <van-popup v-model='showLeftZj3' position='bottom'>
      <van-picker :columns='listJl' show-toolbar :default-index='40' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showLeftZj3 = false' @confirm='onConfirmLeftZj3' />
    </van-popup>
    <van-popup v-model='showLeftZj4' position='bottom'>
      <van-picker :columns='listJl' show-toolbar :default-index='40' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showLeftZj4 = false' @confirm='onConfirmLeftZj4' />
    </van-popup>
    <van-popup v-model='showLeftZj5' position='bottom'>
      <van-picker :columns='listJl' show-toolbar :default-index='40' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showLeftZj5 = false' @confirm='onConfirmLeftZj5' />
    </van-popup>
    <van-popup v-model='showLeftZw0' position='bottom'>
      <van-picker :columns='listZw' show-toolbar :default-index='59' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showLeftZw0 = false' @confirm='onConfirmLeftZw0' />
    </van-popup>
    <van-popup v-model='showLeftZw1' position='bottom'>
      <van-picker :columns='listZw' show-toolbar :default-index='59' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showLeftZw1 = false' @confirm='onConfirmLeftZw1' />
    </van-popup>
    <van-popup v-model='showLeftZw2' position='bottom'>
      <van-picker :columns='listZw' show-toolbar :default-index='59' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showLeftZw2 = false' @confirm='onConfirmLeftZw2' />
    </van-popup>
    <van-popup v-model='showLeftZw3' position='bottom'>
      <van-picker :columns='listZw' show-toolbar :default-index='59' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showLeftZw3 = false' @confirm='onConfirmLeftZw3' />
    </van-popup>
    <van-popup v-model='showLeftZw4' position='bottom'>
      <van-picker :columns='listZw' show-toolbar :default-index='59' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showLeftZw4 = false' @confirm='onConfirmLeftZw4' />
    </van-popup>
    <van-popup v-model='showLeftZw5' position='bottom'>
      <van-picker :columns='listZw' show-toolbar :default-index='59' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showLeftZw5 = false' @confirm='onConfirmLeftZw5' />
    </van-popup>
    <van-popup v-model='showLeftJz0' position='bottom'>
      <van-picker :columns='listShili' show-toolbar :default-index='3' value-key='txt' cancel-button-text='取消'
        confirm-button-text='确定' @cancel='showLeftJz0 = false' @confirm='onConfirmLeftJz0' />
    </van-popup>
    <van-popup v-model='showLeftJz1' position='bottom'>
      <van-picker :columns='listShili' show-toolbar :default-index='3' value-key='txt' cancel-button-text='取消'
        confirm-button-text='确定' @cancel='showLeftJz1 = false' @confirm='onConfirmLeftJz1' />
    </van-popup>
    <van-popup v-model='showLeftJz2' position='bottom'>
      <van-picker :columns='listShili' show-toolbar :default-index='3' value-key='txt' cancel-button-text='取消'
        confirm-button-text='确定' @cancel='showLeftJz2 = false' @confirm='onConfirmLeftJz2' />
    </van-popup>
    <van-popup v-model="isShowConfirm">
      <div class="con_box">
        <div class="pop-btn">
          <h3>提示</h3>
          <p>确定删除该图片吗？</p>
          <span @click="isShowConfirm = false">取消</span>
          <span @click="delImg()">确定</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script lang="script">
import { ImagePreview } from 'vant';
import axios from 'axios'
import { compressImage } from '../assets/js/compass.js';

export default {
  name: 'ysgDetail',
   data() {
    return {
      showSgn: false,
      showLxd: false,
      showGy: false,
      showP: false,
      showSwlx: false,
      showSwcly: false,
      showJmdxt: false,
      showXbj: false,
      showSyj: false,
      showOct: false,
      showYdjc: false,
      showQt: false,
      isShowConfirm: false,
      isConfirm: true,
      isCanInput: false,
      isGlassSl: false,
      info: {},
      showArray: [1,1,1,1,1,1,1,1,1,1,1,1,1,1],
      rightShiliTxt: '',
      leftShiliTxt: '',
      glassesTypeTxt: '',
      gRightShiliTxt: '',
      gLeftShiliTxt: '',
      imgList1: [],
      imgList2: [],
      imgList3: [],
      imgList4: [],
      imgList5: [],
      imgList6: [],
      imgList7: [],
      imgList8: [],
      imgList9: [],
      imgList10: [],
      imgList11: [],
      imgList12: [],
      showSex: false,
      delTypeIndex: '',
      sexTxt: '',
      showBirth: false,
      showArchives: false,
      showRightShili: false,
      showLeftShili: false,
      showGRightShili: false,
      showGLeftShili: false,
      showGlassType: false,
      showRightQj0:false,
      showRightQj1:false,
      showRightQj2:false,
      showRightQj3:false,
      showRightQj4:false,
      showRightQj5:false,
      showRightZj0:false,
      showRightZj1:false,
      showRightZj2:false,
      showRightZj3:false,
      showRightZj4:false,
      showRightZj5:false,
      showRightZw0:false,
      showRightZw1:false,
      showRightZw2:false,
      showRightZw3:false,
      showRightZw4:false,
      showRightZw5:false,
      showLeftQj0: false,
      showLeftQj1:false,
      showLeftQj2:false,
      showLeftQj3:false,
      showLeftQj4:false,
      showLeftQj5:false,
      showLeftZj0:false,
      showLeftZj1:false,
      showLeftZj2:false,
      showLeftZj3:false,
      showLeftZj4:false,
      showLeftZj5:false,
      showLeftZw0:false,
      showLeftZw1:false,
      showLeftZw2:false,
      showLeftZw3:false,
      showLeftZw4:false,
      showLeftZw5:false,
      showRightJz0:false,
      showRightJz1:false,
      showRightJz2:false,
      showLeftJz0: false,
      showLeftJz1: false,
      showLeftJz2: false,
      rightJzTxt0: '',
      rightJzTxt1: '',
      rightJzTxt2: '',
      leftJzTxt0: '',
      leftJzTxt1: '',
      leftJzTxt2: '',
      otherItemImg: require('../assets/img/down.png'),
      currentDate: new Date(new Date().getTime()),
      currentDate1: new Date(new Date().getTime()),
      minDate: new Date(1950, 0, 1),
      imgIndex: '',
      delImgIndex: '',
      listShili: [
        {txt:'5.3(2.0)',val:'5.3'},
        {txt:'5.2(1.5)',val:'5.2'},
        {txt:'5.1(1.2)',val:'5.1'},
        {txt:'5.0(1.0)',val:'5.0'},
        {txt:'4.95(0.9)',val:'4.95'},
        {txt:'4.9(0.8)',val:'4.9'},
        {txt:'4.85(0.7)',val:'4.85'},
        {txt:'4.8(0.6)',val:'4.8'},
        {txt:'4.7(0.5)',val:'4.7'},
        {txt:'4.6(0.4)',val:'4.6'},
        {txt:'4.5(0.3)',val:'4.5'},
        {txt:'4.4(0.25)',val:'4.4'},
        {txt:'4.3(0.2)',val:'4.3'},
        {txt:'4.2(0.15)',val:'4.2'},
        {txt:'4.1(0.12)',val:'4.1'},
        {txt:'4.0(0.1)',val:'4.0'},
        {txt:'3.9(0.08)',val:'3.9'},
        {txt:'3.8(0.06)',val:'3.8'},
        {txt:'3.6(0.04)',val:'3.6'},
        {txt:'3.5(0.03)',val:'3.5'},
        {txt:'3.4(0.025)',val:'3.4'},
        {txt:'3.3(0.02)',val:'3.3'},
        {txt:'3.2(0.016)',val:'3.2'},
        {txt:'3.1(0.012)',val:'3.1'},
        {txt:'3.0(0.01)',val:'3.0'}
      ],
      listGlassType: [
        {txt:'框架眼镜',val:1},
        {txt:'隐形眼镜',val:2},
        {txt:'夜戴角膜塑形镜',val:3}
      ],
      listSex: [
        {txt:'男',val: 0},
        {txt:'女',val:1},
        {txt:'未知',val:2},
      ],
      listJl: [],
      listZw: [],
      // imgPro: 'https://test.yjkok.com/pictures/chatImage/',
      imgPro: 'https://i.yjkok.com/pictures/chatImage',
      token: '',
    }
  },
  mounted() {
    document.title = '编辑档案';
    let jlArray = new Array(), zwArray = new Array(), jlStart = 10;
    jlArray.push(jlStart);
    while (jlStart > -20) {
      jlStart = jlStart - 0.25;
      jlArray.push(jlStart);
    }
    for (let loop = 1; loop <= 180; loop++) {
      zwArray.push(loop);
    }
    this.listJl = jlArray;
    this.listZw = zwArray;
    this.getInfo();
    this.getToken();
  },
  methods: {
    showTable(n) {
      let val = 1-this.showArray[n];
      this.$set(this.showArray,n,val)
    },
    async getInfo() {
      let auth =this.$createAuth(this.$md5);
      let result = await this.$http.get(this.$url.getHeaByUid,{
        uid:  this.$route.query.sid,
        auth: auth.code,
        time: auth.time
      });
      let _this = this;
      if(result.message==='Error: Miss auth parameter.'){
        setTimeout(function(){_this.getInfo();},500);
      } else {
        this.info = result.data.date;
        if(this.info.glassesType) this.isGlassSl = true;
        this.sexTxt =this.getListTxt(this.listSex,this.info.sex)
        this.glassesTypeTxt =this.getListTxt(this.listGlassType,this.info.glassesType)
        this.rightShiliTxt = this.getListTxt(this.listShili,this.info.rightNakedFar)
        this.leftShiliTxt = this.getListTxt(this.listShili,this.info.leftNakedFar)
        this.gRightShiliTxt = this.getListTxt(this.listShili,this.info.rightGlassesFar)
        this.gLeftShiliTxt = this.getListTxt(this.listShili,this.info.leftGlassesFar)
        this.rightJzTxt0 = this.getListTxt(this.listShili,this.info.rightcorrectzhujue)
        this.rightJzTxt1 = this.getListTxt(this.listShili,this.info.rightcorrectchapian)
        this.rightJzTxt2 = this.getListTxt(this.listShili,this.info.rightcorrectzhujue1)
        this.leftJzTxt0 = this.getListTxt(this.listShili,this.info.leftcorrectzhujue)
        this.leftJzTxt1 = this.getListTxt(this.listShili,this.info.leftcorrectchapian)
        this.leftJzTxt2 = this.getListTxt(this.listShili,this.info.leftcorrectzhujue1)

        if(this.info.dlygPicture) this.imgList1 = this.info.dlygPicture.split(",");
        if(this.info.xrygPicture) this.imgList2 = this.info.xrygPicture.split(",");
        if(this.info.dlygsthPicture) this.imgList3 = this.info.dlygsthPicture.split(",");
        if(this.info.xrygsthPicture) this.imgList4 = this.info.xrygsthPicture.split(",");
        if(this.info.dlygfyPicture) this.imgList5 = this.info.dlygfyPicture.split(",");
        if(this.info.xrygfyPicture) this.imgList6 = this.info.xrygfyPicture.split(",");
        if(this.info.righttopographypicture) this.imgList7 = this.info.righttopographypicture.split(",");
        if(this.info.rightbiometricspicture) this.imgList8 = this.info.rightbiometricspicture.split(",");
        if(this.info.leftbiometricspicture) this.imgList9 = this.info.leftbiometricspicture.split(",");
        if(this.info.glassesRecipe) this.imgList10 = this.info.glassesRecipe.split(",");
        if(this.info.visualFunctionPicture) this.imgList11 = this.info.visualFunctionPicture.split(",");
        if(this.info.otherRightPicture) this.imgList12 = this.info.otherRightPicture.split(",");
      }
    },
    async submitInfo() {
      let birth = this.info.birthday.replace(/-/ig,'/');
      let archivesDate = this.info.archivesDate.replace(/-/ig,'/');

      if (new Date(birth) > new Date(archivesDate)) {
        this.$toast('建档日期不能小于出生日期！',3000);
        return;
      } else {
        if (this.isConfirm) {
          this.isConfirm = false;
          if(this.info.birthday) this.info.birthday = new Date(birth).getTime();
          if(this.info.archivesDate) this.info.archivesDate =  new Date(archivesDate).getTime();

          this.info.dlygPicture = this.imgList1.join(",");
          this.info.xrygPicture = this.imgList2.join(",");
          this.info.dlygsthPicture = this.imgList3.join(",");
          this.info.xrygsthPicture = this.imgList4.join(",");
          this.info.dlygfyPicture = this.imgList5.join(",");
          this.info.xrygfyPicture = this.imgList6.join(",");
          this.info.righttopographypicture = this.imgList7.join(",");
          this.info.rightbiometricspicture = this.imgList8.join(",");
          this.info.leftbiometricspicture = this.imgList9.join(",");
          this.info.glassesRecipe = this.imgList10.join(",");
          this.info.visualFunctionPicture = this.imgList11.join(",");
          this.info.otherRightPicture = this.imgList12.join(",")
          let auth = this.$createAuth(this.$md5);
          let info = JSON.stringify(this.info)
          let result = await this.$http.post(
            this.$url.updateHeaInfo+"?auth="+auth.code+"&time="+auth.time,info,
            { headers:{'Content-Type':'application/json;'}
          });
          if(result.message==='Error: Miss auth parameter.'){
            this.$toast("档案编辑失败",3000);
            let _this = this;
            setTimeout(function() {
              _this.isConfirm = true;
            },500)
          } else {
            this.$toast("档案编辑成功",3000);
            history.go(-1);
          }
        }
      }
    },
    getListTxt(list,val) {
      for (let loop=0; loop<list.length; loop++){
        let obj = list[loop];
        if(obj.val==val) {
          return obj.txt;
        }
      }
    },
    onConfirmSex(value) {
      this.info.sex = value.val;
      this.sexTxt = value.txt;
      this.showSex = false;
    },
    onConfirmBirth(value){
      this.info.birthday = this.$dateFormat('YYYY-mm-dd', value);
      this.showBirth = false;
    },
    onConfirmArchives(value){
      this.info.archivesDate = this.$dateFormat('YYYY-mm-dd', value);
      this.showArchives = false;
    },
    onConfirmRightShili(value){
      this.info.rightNakedFar = value.val;
      this.rightShiliTxt = value.txt;
      this.showRightShili = false;
    },
    onConfirmLeftShili(value){
      this.info.leftNakedFar = value.val;
      this.leftShiliTxt = value.txt;
      this.showLeftShili = false;
    },
    onConfirmGRightShili(value){
      this.info.rightGlassesFar = value.val;
      this.gRightShiliTxt = value.txt;
      this.showGRightShili = false;
    },
    onConfirmGLeftShili(value){
      this.info.leftGlassesFar = value.val;
      this.gLeftShiliTxt = value.txt;
      this.showGLeftShili = false;
    },
    onConfirmGlassType(value){
      this.info.glassesType = value.val;
      this.glassesTypeTxt = value.txt;
      this.showGlassType = false;
      this.isGlassSl = value.txt!=''
    },
    onConfirmRightQj0(value){
      this.info.rightBallAvg = value;
      this.showRightQj0 = false;
    },
    onConfirmRightQj1(value){
      this.info.rightBallZhujue = value;
      this.showRightQj1 = false;
    },
    onConfirmRightQj2(value){
      this.info.rightBallAvgAfter = value;
      this.showRightQj2= false;
    },
    onConfirmRightQj3(value){
      this.info.rightballchapian = value;
      this.showRightQj3 = false;
    },
    onConfirmRightQj4(value){
      this.info.rightBallAvgAfter1 = value;
      this.showRightQj4 = false;
    },
    onConfirmRightQj5(value){
      this.info.rightBallZhujue1 = value;
      this.showRightQj5 = false;
    },
    onConfirmRightZj0(value){
      this.info.rightSylAvg = value;
      this.showRightZj0 = false;
    },
    onConfirmRightZj1(value){
      this.info.rightSylZhujue = value;
      this.showRightZj1 = false;
    },
    onConfirmRightZj2(value){
      this.info.rightSylAvgAfter = value;
      this.showRightZj2 = false;
    },
    onConfirmRightZj3(value){
      this.info.rightsylchapian = value;
      this.showRightZj3 = false;
    },
    onConfirmRightZj4(value){
      this.info.rightSylAvgAfter1 = value;
      this.showRightZj4 = false;
    },
    onConfirmRightZj5(value){
      this.info.rightSylZhujue1 = value;
      this.showRightZj5 = false;
    },
    onConfirmRightZw0(value){
      this.info.rightAxialAvg = value;
      this.showRightZw0 = false;
    },
    onConfirmRightZw1(value){
      this.info.rightAxialZhujue = value;
      this.showRightZw1 = false;
    },
    onConfirmRightZw2(value){
      this.info.rightAxialAvgAfter = value;
      this.showRightZw2 = false;
    },
    onConfirmRightZw3(value){
      this.info.rightaxialchapian = value;
      this.showRightZw3 = false;
    },
    onConfirmRightZw4(value){
      this.info.rightAxialAvgAfter1 = value;
      this.showRightZw4 = false;
    },
    onConfirmRightZw5(value){
      this.info.rightAxialZhujue1 = value;
      this.showRightZw5 = false;
    },
    onConfirmRightJz0(value){
      this.info.rightcorrectzhujue = value.val;
      this.rightJzTxt0 = value.txt;
      alert(this.rightJzTxt0 )
      this.showRightJz0 = false;
    },
    onConfirmRightJz1(value){
      this.info.rightcorrectchapian = value.val;
      this.rightJzTxt1 = value.txt;
      this.showRightJz1 = false;
    },
    onConfirmRightJz2(value){
      this.info.rightcorrectzhujue1 = value.val;
      this.rightJzTxt2 = value.txt;
      this.showRightJz2 = false;
    },
    onConfirmLeftQj0(value){
      this.info.leftBallAvg = value;
      this.showLeftQj0 = false;
    },
    onConfirmLeftQj1(value){
      this.info.leftBallZhujue = value;
      this.showLeftQj1 = false;
    },
    onConfirmLeftQj2(value){
      this.info.leftBallAvgAfter = value;
      this.showLeftQj2 = false;
    },
    onConfirmLeftQj3(value){
      this.info.leftballchapian = value;
      this.showLeftQj3 = false;
    },
    onConfirmLeftQj4(value){
      this.info.leftBallAvgAfter1 = value;
      this.showLeftQj4 = false;
    },
    onConfirmLeftQj5(value){
      this.info.leftBallZhujue1 = value;
      this.showLeftQj5 = false;
    },
    onConfirmLeftZj0(value){
      this.info.leftSylAvg = value;
      this.showLeftZj0 = false;
    },
    onConfirmLeftZj1(value){
      this.info.leftSylZhujue = value;
      this.showLeftZj1 = false;
    },
    onConfirmLeftZj2(value){
      this.info.leftSylAvgAfter = value;
      this.showLeftZj2 = false;
    },
    onConfirmLeftZj3(value){
      this.info.leftsylchapian = value;
      this.showLeftZj3 = false;
    },
    onConfirmLeftZj4(value){
      this.info.leftSylAvgAfter1 = value;
      this.showLeftZj4 = false;
    },
    onConfirmLeftZj5(value){
      this.info.leftSylZhujue1 = value;
      this.showLeftZj5 = false;
    },
    onConfirmLeftZw0(value){
      this.info.leftAxialAvg = value;
      this.showLeftZw0 = false;
    },
    onConfirmLeftZw1(value){
      this.info.leftAxialZhujue = value;
      this.showLeftZw1 = false;
    },
    onConfirmLeftZw2(value){
      this.info.leftAxialAvgAfter = value;
      this.showLeftZw2 = false;
    },
    onConfirmLeftZw3(value){
      this.info.leftaxialchapian = value;
      this.showLeftZw3 = false;
    },
    onConfirmLeftZw4(value){
      this.info.leftAxialAvgAfter1 = value;
      this.showLeftZw4 = false;
    },
    onConfirmLeftZw5(value){
      this.info.leftAxialZhujue1 = value;
      this.showLeftZw5 = false;
    },
    onConfirmLeftJz0(value){
      this.info.leftcorrectzhujue= value.val;
      this.leftJzTxt0 = value.txt;
      this.showLeftJz0 = false;
    },
    onConfirmLeftJz1(value){
      this.info.leftcorrectchapian= value.val;
      this.leftJzTxt1 = value.txt;
      this.showLeftJz1 = false;
    },
    onConfirmLeftJz2(value){
      this.info.leftcorrectzhujue1= value.val;
      this.leftJzTxt2 = value.txt;
      this.showLeftJz2 = false;
    },
    setImgIndex(index) {
      this.imgIndex=index
    },
        /**
     * 上传图片
    */
    async uploadSuccess(file, filename) {
      let formData = new FormData();

      let auth =this.$createAuth(this.$md5);
      // 把文件信息添加进如对象
      formData.append('images', file, filename)
      formData.append('hospitalId', this.$route.query.hospitalId)

      formData.append('auth', auth.code)
      formData.append('time', auth.time)
      this.$toast.loading('上传中');
      let config = {headers:{'Content-Type':'multipart/form-data'}};
      const result = await this.$http.post(this.$url.uploadPictures, formData,config);

      let pic = result.data.pictures[0];
      if(this.imgIndex==1) this.imgList1.push(pic);
      if(this.imgIndex==2) this.imgList2.push(pic);
      if(this.imgIndex==3) this.imgList3.push(pic);
      if(this.imgIndex==4) this.imgList4.push(pic);
      if(this.imgIndex==5) this.imgList5.push(pic);
      if(this.imgIndex==6) this.imgList6.push(pic);
      if(this.imgIndex==7) this.imgList7.push(pic);
      if(this.imgIndex==8) this.imgList8.push(pic);
      if(this.imgIndex==9) this.imgList9.push(pic);
      if(this.imgIndex==10) this.imgList10.push(pic);
      if(this.imgIndex==11) this.imgList11.push(pic);
      if(this.imgIndex==12) this.imgList12.push(pic);
      if(this.imgIndex <= 6)this.ocrImg(pic, this.imgIndex);
    },
    afterRead(file) {
      compressImage(file.content).then(result => {
      if (result.size > file.file.size){
        //压缩后比原来更大，则将原图上传
        this.uploadSuccess(file.file, file.file.name);
      } else {
        //压缩后比原来小，上传压缩后的
        this.uploadSuccess(result, file.file.name)
      }
      })
    },
    goDel(index,n) {
      this.isShowConfirm = true;
      this.delImgIndx = index;
      this.delTypeIndex = n;
    },
    goPriview(src) {
      let listImg = [];
      if(src.indexOf(".pdf")>=0) {
        window.open(src)
      }else{
      listImg.push(src);
      this.isShowTip = 1;
      let _this = this;
      ImagePreview({
        images: listImg, startPosition: 0,
        showIndex: false,
        onClose() {
          _this.isShowTip = 0;
        }
      });}
    },
    /**
     * 删除照片
    */
    delImg() {
      if(this.delTypeIndex==1) this.imgList1.splice(this.delImgIndx, 1);
      if(this.delTypeIndex==2) this.imgList2.splice(this.delImgIndx, 1);
      if(this.delTypeIndex==3) this.imgList3.splice(this.delImgIndx, 1);
      if(this.delTypeIndex==4) this.imgList4.splice(this.delImgIndx, 1);
      if(this.delTypeIndex==5) this.imgList5.splice(this.delImgIndx, 1);
      if(this.delTypeIndex==6) this.imgList6.splice(this.delImgIndx, 1);
      if(this.delTypeIndex==7) this.imgList7.splice(this.delImgIndx, 1);
      if(this.delTypeIndex==8) this.imgList8.splice(this.delImgIndx, 1);
      if(this.delTypeIndex==9) this.imgList9.splice(this.delImgIndx, 1);
      if(this.delTypeIndex==10) this.imgList10.splice(this.delImgIndx, 1);
      if(this.delTypeIndex==11) this.imgList11.splice(this.delImgIndx, 1);
      if(this.delTypeIndex==12) this.imgList12.splice(this.delImgIndx, 1);
      this.isShowConfirm = false;
    },
    async getToken() {
      axios({
        url: '/oauth/2.0/token?grant_type=client_credentials&client_id=XXiOGimN9gBvN6IQ6rZbmfTH&client_secret=BqF47yPTlCt3XyrURVtmpG1au4lhDU5Y',
        method: 'post',
      }).then(res => {
        this.token = res.data.access_token;
      });
    },

    async ocrImg(img, imgIndex) {
      axios({
        url: `/baiduApi/rest/2.0/ocr/v1/accurate?access_token=${this.token}&url=${img}`,
        method: 'post',
      }).then(res => {
        let wordList = res.data.words_result;
        if (wordList && wordList.length > 0) {
          let wordRow = [];
          let hasPosition = [];
          let rowIndex = 0;
          wordList.forEach((item) => {
            if (hasPosition.length > 0) {
              let temp = hasPosition.filter(itemPosition => Math.abs(itemPosition.top - item.location.top) < 10);

              if (temp && temp.length > 0) {
                let tempObj = temp[0];
                wordRow[tempObj.index].rowText += item.words.split(/[\t\r\f\n\s]*/g).join('');
              } else {
                let tempIndex = hasPosition.length;
                hasPosition.push({ top: item.location.top, index: tempIndex });
                wordRow.push({
                  rowText: item.words.split(/[\t\r\f\n\s]*/g).join(''),
                  rowIndex: tempIndex,
                })
              }
            } else {
              hasPosition.push({ top: item.location.top, index: rowIndex });
              wordRow.push({
                rowText: item.words.split(/[\t\r\f\n\s]*/g).join(''),
                rowIndex,
              })
            }
          });

          let rData = [], lData = [], seRdata = '', seLdata = '', pdData = '';
          let numberRsca = '-1', numberSeR = '-1', numberSeL = '-1';
          let numberLdataR = '-1', numberLdataL = '-1', numberPs = '-1';
          let numberPd = '-1', numberLsca = '-1';
          let tempRSCA = wordRow.filter(item => item.rowText == '<R>SCA' || item.rowText == '<R>CA');
          if (tempRSCA && tempRSCA.length > 0) numberRsca = tempRSCA[0].rowIndex;
          let tempSE = wordRow.filter(item => item.rowText.indexOf('S.E.') >= 0);
          if (tempSE && tempSE.length > 0) {
            numberSeR = tempSE[0].rowIndex;
            numberSeL = tempSE[1].rowIndex;
          }
          let tempLDATA = wordRow.filter(item => item.rowText == 'L.DATA');
          if (tempLDATA && tempLDATA.length > 0) {
            numberLdataR = tempLDATA[0].rowIndex;
            numberLdataL = tempLDATA[1].rowIndex;
          }
          let tempPS = wordRow.filter(item => item.rowText.indexOf('PS') >= 0);
          if (tempPS && tempPS.length > 0) numberPs = tempPS[0].rowIndex;
          let tempPD = wordRow.filter(item => item.rowText.indexOf('PD') >= 0);
          if (tempPD && tempPD.length > 0) numberPd = tempPD[0].rowIndex;
          let tempLSCA = wordRow.filter(item => item.rowText == '<L>SCA' || item.rowText == '<L>CA');
          if (tempLSCA && tempLSCA.length > 0) numberLsca = tempLSCA[0].rowIndex;
          wordRow.forEach(item => {
            if (numberRsca > 0 && item.rowIndex > numberRsca && item.rowIndex < numberSeR) {
              rData.push(this.formatSCAData(item.rowText))
            }
            if (numberRsca > 0 && item.rowIndex > numberRsca && item.rowIndex < numberLdataR) {
              rData.push(this.formatSCAData(item.rowText))
            }
            if (numberLsca > 0 && item.rowIndex > numberLsca && item.rowIndex < numberSeL) {
              lData.push(this.formatSCAData(item.rowText))
            }
            if (numberLsca > 0 && item.rowIndex > numberLsca && item.rowIndex < numberLdataL) {
              lData.push(this.formatSCAData(item.rowText))
            }
            if (numberSeR > 0 && item.rowIndex == numberSeR) {
              seRdata = item.rowText.replace('S.E.', '');
            }
            if (numberSeL > 0 && item.rowIndex == numberSeL) {
              seLdata = item.rowText.replace('S.E.', '');
            }
            if (numberPd > 0 && item.rowIndex == numberPd) {
              pdData = item.rowText.replace('PD', '');
              pdData = pdData.replace(':', '');
            }
          });
          let endRData = rData[rData.length - 1];
          let endLData = lData[lData.length - 1];
          let arr = [];
          if(imgIndex==1) {
            arr = ['rightBallAvg','rightSylAvg','rightAxialAvg','leftBallAvg','leftSylAvg','leftAxialAvg','pupilDistance'];
            this.setSelectValue(arr, endRData, endLData, pdData);
          }
          if(imgIndex==2) {
            arr = ['rightBallZhujue','rightSylZhujue','rightAxialZhujue','leftBallZhujue','leftSylZhujue','leftAxialZhujue','xrygPupilDistance'];
            this.setSelectValue(arr, endRData, endLData, pdData);
          }
          if(imgIndex==3) {
            arr = ['rightBallAvgAfter','rightSylAvgAfter','rightAxialAvgAfter','leftBallAvgAfter','leftSylAvgAfter','leftAxialAvgAfter','pupilDistanceAfter'];
            this.setSelectValue(arr, endRData, endLData, pdData);
          }
          if(imgIndex==4) {
            arr = ['rightballchapian','rightsylchapian','rightaxialchapian','leftballchapian','leftsylchapian','leftaxialchapian','xrygsthPupilDistance'];
            this.setSelectValue(arr, endRData, endLData, pdData);
          }
          if(imgIndex==5) {
            arr = ['rightBallAvgAfter1','rightSylAvgAfter1','rightAxialAvgAfter1','leftBallAvgAfter1','leftSylAvgAfter1','leftAxialAvgAfter1','pupilDistanceAfter1'];
            this.setSelectValue(arr, endRData, endLData, pdData);
          }
          if(imgIndex==6) {
            arr = ['rightBallZhujue1','rightSylZhujue1','rightAxialZhujue1','leftBallZhujue1','leftSylZhujue1','leftAxialZhujue1','xrygfyPupilDistance'];
            this.setSelectValue(arr, endRData, endLData, pdData);
            this.$toast('图片识别完毕，请核对数据！', 3000)
          }
        }
      });
    },
    setSelectValue(arr, endRData, endLData, pdData) {
      this.info[arr[0]] = endRData.s;
      this.info[arr[1]] = endRData.c;
      this.info[arr[2]] = endRData.a;
      this.info[arr[3]] = endLData.s;
      this.info[arr[4]] = endLData.c;
      this.info[arr[5]] = endLData.a;
      this.info[arr[6]] = pdData;
    },
    formatSCAData(value) {
      value = value.replace('<','');
      value = value.replace('>','');
      value = value.replace(/×/ig,'');
      let s = value.substring(0, value.indexOf('.') + 3);
      let temp = value.substring(s.length);
      let c = temp.substring(0, temp.indexOf('.') + 3);
      let a = value.substring(s.length + c.length);
      return { s, c, a };
    }
  }
}

</script>
<style lang="less" scope>
.container {
  padding: 0 0.3rem 0.3rem;
}

.reports-table {
  width: 7.5rem;
  margin-left: -0.3rem;

  td {
    padding: 0.2rem 0.1rem;
    height: 1rem;
    box-sizing: border-box;

    &.first {
      background: #fcfcfc;
    }

    &.base {
      width: 1.5rem;
    }

    &.big {
      width: 2.25rem;
    }

    &.big2 {
      width: 2rem;
    }

    &.big3 {
      width: 3.75rem;
    }

    &.noborder {
      border-left: none;
    }

    textarea {
      margin: 0.3rem;
      height: 1rem;
      width: 6.6rem;
      border: 0.01rem solid #ccc;
      padding: 0.1rem;
    }

    input {
      width: 1.8rem;
      padding: 0.1rem;
      box-sizing: border-box;

      &.small {
        width: 1.5rem;
      }

      &.small1 {
        width: 1.3rem;
      }

      &.small2 {
        width: 1rem;
      }
    }

  }
}

.submit-btn {
  width: 4.5rem;
  margin: 0.3rem 0 0;
  background-color: #5CC4AB;
  color: #fff;
  border-radius: 5px;
}

.other-photo {
  width: 1rem;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  font-size: 0.4rem;
  border: 0.01rem solid #ddd;
}

.van-popup {
  border-radius: 10px;

  .con_box {
    width: 5.5rem;
    line-height: 1;
    text-align: center;
    color: #4d5c82;
    padding: 15px;
    box-sizing: border-box;

    h3 {
      width: 5.5rem;
      font-size: 20px;
      margin-top: 10px;
      margin-bottom: 20px;
    }

    p {
      width: 5.5rem;
      font-size: 17px;
      margin-bottom: 30px;
    }

    .pop-btn {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      >span {
        display: block;
        width: 114px;
        background-color: #e0e5f5;
        text-align: center;
        line-height: 44px;
        font-size: 17px;
      }

      >span:last-of-type {
        background-color: #12B5C4;
        color: #ffffff;
      }
    }
  }
}

.show-table {
  padding: 0.3rem 0;
  background: #fcfcfc;
  width: 7.5rem;
  margin-left: -0.3rem;

  img {
    position: relative;
    width: 0.36rem;
    top: 0.1rem;
    left: 0.2rem;
  }
}

.dz-img {
  img {
    width: 2.5rem;
    margin: 0.3rem auto;
  }

  span {
    display: inline-block;
    width: 1.25rem;
    text-align: center;
    font-size: 0.28rem;
    color: #666;
  }
}

.flex {
  display: flex;
}

.down-img {
  width: 0.36rem;
  margin-top: 0.1rem;
}

.txt-left {
  text-align: left;
}

.reports-table td input.big-txt {
  width: 3rem;
}

.module-txt {
  width: 7.5rem;
  margin-left: -0.3rem;
  padding: 0.25rem 0;
  font-size: 0.32rem;
  text-align: center;
  color: #666;
  border-top: 0.01rem solid #CCC;
  background: rgba(0, 172, 96, 0.3);
}

.menudown {
  position: relative;
  top: 0.05rem;
  width: 0.3rem;
  margin-left: 0.2rem;
}

.menuup {
  position: relative;
  top: 0.05rem;
  width: 0.3rem;
  margin-left: 0.2rem;
  transform: rotate(180deg);
}

.input-div {
  display: flex;
  border: 1px solid #ccc;
  border-radius: 0.05rem;
  padding: 0.1rem;

  input {
    border: none;
  }

  img {
    width: 0.3rem;
    max-width: 0.3rem;
  }
}

.input-common {
  border: 1px solid #ccc;
  border-radius: 0.05rem;
  padding: 0.1rem;
}
</style>
